export default "__VITE_ASSET__Bo1zpl5v__"